const not = (...predicates) => {
  return traffic => {
    return predicates.every(predicate => {
      return !predicate(traffic)
    })
  }
}

export default not



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/predicates/not.js